<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Users</h4>
              <p class="card-category"></p>
              <button class="btn btn-info btn-fill float-right" id="show-modal" v-on:click="showAddModal()">Add
              </button>
            </template>
            <l-table-actions :actions="tableUsers.actions"
                             :columns="tableUsers.columns"
                             :data="tableUsers.data"
                             class="table-hover table-striped">
            </l-table-actions>
          </card>
        </div>
      </div>
    </div>


    <modal :height="700" name="modalUser">
      <div class="modalStyle">
        <h4 class="card-title" v-if="!this.user.edit">Add user</h4>
        <h4 class="card-title" v-if="this.user.edit">Edit user</h4>
        <form @submit="formUserSubmit" id="formUser">
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="name"
                          label="Name"
                          name="name"
                          placeholder="Name"
                          type="text"
                          v-model="user.name">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="surname"
                          label="Surname"
                          name="surname"
                          placeholder="Surname"
                          type="text"
                          v-model="user.surname">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="email"
                          label="E-mail"
                          name="email"
                          placeholder="E-mail"
                          type="email"
                          v-model="user.email">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label for="adminCheckbox">Admin &nbsp</label>
              <input id="adminCheckbox"
                     type="checkbox"
                     v-model="user.admin">
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label for="activeCheckbox">Active &nbsp</label>
              <input id="activeCheckbox"
                     type="checkbox"
                     v-model="user.active">
            </div>
          </div>

          <div class="form-group">
            <div class="col-md-12">
              <base-input id="password"
                          label="Password"
                          name="password"
                          placeholder="Password"
                          type="password"
                          v-model="user.password">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="description"
                          label="Description"
                          name="description"
                          placeholder="Description"
                          type="text"
                          v-model="user.description">
              </base-input>
            </div>
          </div>

          <div class="buttonModal">
            <button class="btn btn-info btn-fill float-right" v-if="!this.user.edit" v-on:click="closeAddModal()">Add
            </button>
            <button class="btn btn-info btn-fill float-right" v-if="this.user.edit" v-on:click="closeAddModal()">Save
            </button>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>
<script>

    import LTableActions from 'src/components/TableActions.vue'
    import Card from 'src/components/Cards/Card.vue'
    import 'vue-datetime/dist/vue-datetime.css'
    import EventBus from "../../event-bus";

    const Vue = window.Vue;

    const tableColumns = ['Id', 'Email', 'Active', 'Admin'];
    const tableData = [{}];

    export default {
        name: "UsersPage",
        components: {
            LTableActions,
            Card
        },
        data() {
            return {
                status: 'not_accepted',
                idAdmin: false,
                tableUsers: {
                    columns: [...tableColumns],
                    data: [...tableData],
                    actions: [
                        {
                            icon: 'info',
                            handler: this.detailsItem
                        },
                        {
                            icon: 'edit',
                            handler: this.editItem
                        },
                        {
                          icon: 'trash-alt',
                          handler: this.deleteItem
                        }
                    ]
                },
                app: {
                    colNum: 2,
                    grids: Array.from({length: 5}, _ => 100 + 300 * Math.random())
                },

                user: {
                    id: '',
                    name: '',
                    surname: '',
                    email: '',
                    admin: '',
                    active: '',
                    password: '',
                    description: '',
                    edit: false
                }

            }
        },

        mounted() {
            EventBus.$emit('EVENT_PATHS', [["/#/users/list", 'Users']]);
            this.loadUsers();
        },
        methods: {
            updateValue(event) {
                const value = event.target.value;
                if (String(value).length <= 10) {
                    this.amount = value
                }
                this.$forceUpdate()
            },

            increase() {
                this.colNum += 1;
            },
            decrease() {
                if (this.colNum > 1) {
                    this.colNum -= 1;
                }
            },
            add() {
                this.grids.push(100 + 300 * Math.random());
            },
            remove() {
                this.grids.pop();
            },
            reset() {
                this.grids = Array.from({length: 5}, _ => 100 + 300 * Math.random());
            },

            loadUsers() {
                this.$http.get('user/list')
                    .then(result => {
                        this.tableUsers.data = result.data;
                    }, error => {
                        console.error(error);
                    });
            },
            detailsItem(item) {
                this.$router.push('/users/details/' + item.id);
            },
            editItem(item) {
                console.info("Edit item " + item.id);

                this.$http.get('user/' + item.id)
                    .then(result => {
                        console.info(result.data);
                        this.user = result.data;
                        this.user.edit = true;
                        this.$modal.show('modalUser');
                    }, error => {
                        console.error(error);
                    });
            },
            deleteItem(item) {
                this.$http.delete('user/' + item.id)
                    .then(result => {
                        console.info("Success");
                        this.loadUsers();
                    }, error => {
                        console.error(error);
                    });
            },
            showAddModal() {
                this.user.id = '';
                this.user.name = '';
                this.user.surname = '';
                this.user.email = '';
                this.user.admin = '';
                this.user.active = '';
                this.user.password = '';
                this.user.description = '';
                this.$modal.show('modalUser');
            },
            closeAddModal() {
                this.$modal.hide('modalUser');
            },
            formUserSubmit(e) {
                e.preventDefault();

                let url = 'user';
                let method = this.$http.post;

                if (this.user.edit) {
                    url += '/' + this.user.id;
                    method = this.$http.put;
                }

                method(url, {
                    'name': this.user.name,
                    'city': this.user.surname,
                    'email': this.user.email,
                    'admin': this.user.admin,
                    'active': this.user.active,
                    'password': this.user.password,
                    'description': this.user.description,


                }).then(result => {
                    console.info("Success");
                    this.loadUsers();
                }, error => {
                    console.error(error);
                });
            },
        }
    }

    function maxLengthCheck(object) {
        if (object.value.length > object.maxLength)
            object.value = object.value.slice(0, object.maxLength)
    }
    function myFunction() {
        var checkBox = document.getElementById("myCheck");
        var text = document.getElementById("text");
        if (checkBox.checked == true){
            text.style.display = "block";
        } else {
            text.style.display = "none";
        }
    }
</script>

<style scoped>
  .modalStyle {
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .buttonModal {
    margin-top: 30px;
    margin-right: 20px;
  }

  @Datetime {
    width: 700px;

  }

</style>
